import { DateTime } from 'luxon';

export const normalizeKey = (key: string): string => key.replace(/[^a-zA-Z0-9]/g, '_');

export const getDeviceName = ({
  barge,
  device,
}: {
  barge: { name: string };
  device: { name: string };
}) => {
  return `${device.name} (${barge.name})`;
};

export const isEmerson = (name?: string) => {
  return name ? name.includes('Emerson') : false;
};

export const getExportFileName = ({
  bargeName,
  deviceName,
  date = DateTime.now().toFormat('yyyyMMddHHmmss'),
}: {
  bargeName: string;
  deviceName: string;
  date?: string;
}) => {
  return `ADP_datalogger_${bargeName}_${deviceName}_${date}`;
};

export const getAlarmsExportFileName = () => {
  return `ADP_datalogger_alarmlogs_${DateTime.now().toFormat('yyyyMMddHHmmss')}`;
};

export const getBunkeringLogsExportFileName = () => {
  return `ADP_datalogger_bunkeringlogs_${DateTime.now().toFormat('yyyyMMddHHmmss')}`;
};

export const getRawDataExportFileName = (bmtNumber: string | number) => {
  return `ADP_datalogger_rawdata_${bmtNumber}_${DateTime.now().toFormat('yyyyMMddHHmmss')}`;
};

export const getInitials = (name?: string, lastName?: string) => {
  if (!name && !lastName) return null;

  const firstInitial = name ? name.charAt(0).toUpperCase() : '';
  const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';

  return `${firstInitial}${lastInitial}`;
};

export const decodeJwtToken = (token: string) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error('Error decoding JWT token:', e);
    return null;
  }
};
